import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';

const propType = {
  _id: PropTypes.string,
  slug: PropTypes.string,
  name: PropTypes.string,
  summary: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.oneOfType([
    PropTypes.shape(ImageProp.propType),
    PropTypes.string,
  ]),
  startDate: PropTypes.number,
  endDate: PropTypes.number,
  imageSquare: PropTypes.shape(ImageProp.propType),
  inAppProduct: PropTypes.shape({ price: PropTypes.number.isRequired }),
  inAppPromotion: PropTypes.shape({ price: PropTypes.number.isRequired }),
  skills: PropTypes.string,
  type: PropTypes.string,
  contentAvailableBeforePayment: PropTypes.bool,
  participationAreVisible: PropTypes.bool,
};
const PARTICIPATION_STAT = {
  INVITED: 'invited',
  NOT_INVITED: 'notInvited',
  SUBSCRIBED: 'subscribed',
  NOT_SUBSCRIBED: 'notSubscribed',
  PARTICIPATED: 'participated',
  DIDNT_PARTICIPATE: 'didntParticipate',
  SUBSCRIBED_NOT_PAID: 'subscribedNotPaid',
};

const PARTICIPATION_STATUS = Object.values(PARTICIPATION_STAT);

export { PARTICIPATION_STAT, PARTICIPATION_STATUS };

export default { propType };
